import { Group } from './Group';
import { Section } from './Section';

export const AnchorLayout = {
  Group,
  Section,
};
